var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" 云ICU后台管理系统©2021 Created by 优屏研发团队 ")])}
var staticRenderFns = []

export { render, staticRenderFns }